import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { CategoriaEmpresa } from 'src/app/core/categoria-empresa';
import { ToastService } from 'src/app/services/toast/toast.service';
import { MatriculaSecretaria } from '../../../core/matricula-secretaria';
import { NiveisTurmas } from '../../../core/niveis-turmas';
import { TipoTurno } from '../../../core/tipo-turno';
import { Unidade } from '../../../core/unidade';
import { MatriculaSecretariaService } from '../../../services/matricula-secretaria/matricula-secretaria.service';
import { NiveisTurmasService } from '../../../services/niveis-turmas/niveis-turmas.service';
import { UnidadeService } from '../../../services/unidade/unidade.service';

@Component({
  selector: 'app-cadastrar-matricula-secretaria',
  templateUrl: './cadastrar-matricula-secretaria.component.html',
  styleUrls: ['./cadastrar-matricula-secretaria.component.css']
})
export class CadastrarMatriculaSecretariaComponent implements OnInit {

  categoriaEmpresa: CategoriaEmpresa;

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarBotaoCadastrar = true;
  mostrarBotaoAtualizar = true;
  
  tipoTurno: TipoTurno = new TipoTurno();
  niveisTurma: NiveisTurmas[];
  unidades: Unidade[];

  matriculaSecretaria: MatriculaSecretaria = new MatriculaSecretaria();

  isAtualizar = false;

  constructor(
    private matriculaSecretariaService: MatriculaSecretariaService,
    private unidadeService: UnidadeService,
    private nivelTurmaService: NiveisTurmasService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private toastService: ToastService
  ) {}


  ngOnInit() {
    this.initObjetos();
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    if (!this.perfilAcesso.insere){
      this.mostrarBotaoCadastrar = false;
    }

    if (!this.perfilAcesso.altera){
      this.mostrarBotaoAtualizar = false;
    }

    this.nivelTurmaService.getAll().subscribe((niveisTurma: NiveisTurmas[]) => {
      this.niveisTurma = niveisTurma;
    });

    this.unidadeService.getAllUnidadeParaCombo().subscribe((unidades: Unidade[])=> {
      this.unidades = unidades;
      if (this.matriculaSecretaria?.unidade?.idUnidade) {
        const unidadeCorrespondente = this.unidades.find(u => u.idUnidade === this.matriculaSecretaria.unidade.idUnidade);
        if (unidadeCorrespondente) {
          this.matriculaSecretaria.unidade = unidadeCorrespondente;
        }
      }
    });

    let id: number;
    id = this.activatedRoute.snapshot.queryParams.id ? this.activatedRoute.snapshot.queryParams.id : null;
    if (id) {
      this.isAtualizar = true;
      this.matriculaSecretariaService.getById(id).subscribe((matriculaSecretaria: MatriculaSecretaria) => {
        this.matriculaSecretaria = matriculaSecretaria;
        if(!this.matriculaSecretaria.nivelTurma) {
          this.matriculaSecretaria.nivelTurma = new NiveisTurmas();
        }
      });
    }
  }

  initObjetos() {
    this.matriculaSecretaria = new MatriculaSecretaria();
    this.matriculaSecretaria.nivelTurma = new NiveisTurmas();
  }

  mostrarBotaoLimpar(){
    if (this.isAtualizar) { return false; }
    if (!this.mostrarBotaoAtualizar) { return false; }
    if (!this.mostrarBotaoCadastrar) { return false; }

    return true;
  }

  cadastrar() {
    this.matriculaSecretariaService.cadastrar(this.matriculaSecretaria).subscribe(() => {
      this.location.back();
      this.toastService.showSucesso('Matrícula cadastrada com sucesso');
    });
  }

  retiraMascara(objeto) {
    return objeto.replace(/\D/g, '');
  }

  limpar() {
    this.initObjetos();
  }

  cancelar() {
    this.location.back();
  }


  atualizar() {
    this.matriculaSecretariaService.alterar(this.matriculaSecretaria).subscribe(() => {
      this.location.back();
      this.toastService.showSucesso('Matrícula atualizada com sucesso');
    });

  }

  setUnidade(): void {
    const id = this.matriculaSecretaria?.unidade?.idUnidade;

    if (!id) {
      this.matriculaSecretaria.unidade = new Unidade();
      return;
    }

    const origem = (this.unidades ?? []).find(u => u.idUnidade === id);

    this.matriculaSecretaria.unidade = origem
      ? Object.assign(new Unidade(), origem)
      : new Unidade();
  }

  setNivelTurma(): void {
    const id = this.matriculaSecretaria?.nivelTurma?.id;

    // Sem id → zera para um novo objeto
    if (!id) {
      this.matriculaSecretaria.nivelTurma = new NiveisTurmas();
      return;
    }

    // Busca com defesa caso o array esteja indefinido
    const origem = (this.niveisTurma ?? []).find(n => n.id === id);

    // Se achou, clona preservando a classe; senão, novo
    this.matriculaSecretaria.nivelTurma = origem
      ? Object.assign(new NiveisTurmas(), origem)
      : new NiveisTurmas();
  }

}
